import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import { createAppQueryClient } from './api/queryClient'
import './index.css'

// Centralised factory: default options + the global MutationCache that
// invalidates the ['streak'] query after ANY successful mutation.
const queryClient = createAppQueryClient()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#0A3E4F',
            color: '#E6F4F8',
            border: '1px solid #1E96B5',
          },
          success: {
            iconTheme: { primary: '#C9A55C', secondary: '#0A3E4F' },
          },
          error: {
            style: { background: '#5A2A12', color: '#E6F4F8', border: '1px solid #7A3E1F' },
          },
        }}
      />
    </QueryClientProvider>
  </StrictMode>,
)
